<template>
  <el-table-column :width="width" :label="label" :align="align">
    <template v-slot="{ row }">
      <v-avatar-nickname
        :value="row[avatarKey]"
        :nickname="row[nicknameKey]"
        :is-center="true"
        :nickname-overflow="nicknameOverflow"
        :link-page-name="linkPageName"
        :link-page-id="row[linkPageId]"
        :avatar-size="50"
      />
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '132',
    },
    label: {
      type: String,
      default: '昵称',
    },
    avatarKey: {
      type: String,
      default: 'avatar',
    },
    nicknameKey: {
      type: String,
      default: 'nickname',
    },
    nicknameOverflow: {
      type: Boolean,
      default: true,
    },
    linkPageName: String,
    linkPageId: {
      type: String,
      default: 'id',
    },
    align: {
      type: String,
      default: '',
    },
  },
};
</script>
